module.exports = {"pathContext":{"name":"Orderable","kind":"UNION","type":"OBJECT","fields":null,"description":null,"enumValues":null,"possibleTypes":[{"kind":"OBJECT","name":"Product","ofType":null},{"kind":"OBJECT","name":"ProductPackage","ofType":null}]}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/union-orderable.json
// module id = 2144
// module chunks = 65644574184402